import React from 'react';

const Error404 = () => {
    return (
        <div className="text-center mt-5 pt-5">
            <h2>404 Error Page</h2>
        </div>
    );
};

export default Error404;